import * as React from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { IAuthState } from '../../../../services/auth/models';
import ForgottenPasswordForm from './components/ForgottenPasswordForm';
import { Button } from 'react-bootstrap';

interface IForgottenPasswordProps {
  email?: string;
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
}

class ForgottenPassword extends React.Component<IForgottenPasswordProps, any> {

  private handleSubmit = (values) => {
    this.setState({ email: values.email });
    const { actions } = this.props;
    actions.auth.forgottenPassword(values.email);
  }

  private resendLink = (values) => {
    this.setState({ resendLinkDisabled: true });
    const { actions, email } = this.props;
    actions.auth.forgottenPassword(email);
    setTimeout(() => {
      this.setState({ resendLinkDisabled: false });
    }, 30000);
  }

  private isRequestPending = () => {
    const { auth } = this.props;

    return (auth.error.remind || []).filter((error) => {
      return error.detail && error.detail.toLowerCase().trim() === 'pending password reset';
    }).length > 0;
  }

  private goToLogin = () => {
    const { actions } = this.props;
    actions.auth.logout(); // we want to reset the state so the user can enter the email again, so no actions.push('/auth/login');
  }

  private sectionTitle = (children) => {
    const { auth } = this.props;

    return (
      <div className="customer-section-title">
        <div className={'login-form-title'} style={{ display: 'flex' }}>
          <div style={{flex: 1}}>Forgotten Password</div>
          <div style={{flex: 1, textAlign: 'right'}}>
            <Button
              onClick={this.goToLogin}
              bsStyle="primary"
              type="submit"
              bsSize="small"
              className="secondary-button n-expand"
            >{!auth.resetPassword ? '< BACK' : 'Return to sign in page'}
            </Button>
          </div>
        </div>
        {children}
      </div>
    );
  }

  private showForm = () => {
    const { auth, email } = this.props;

    return (
      <>
        {this.sectionTitle((
          !auth.resetPassword &&
          <h4 className={'forgotten-password-title-text'} style={{ paddingLeft: '15px', paddingRight: '15px' }}>
            Please provide the email you entered when you purchased your travel insurance policy, to reset your
            password.
          </h4>
        ))}

        {!auth.resetPassword ? (
          <div className={'white-card'}>
            <ForgottenPasswordForm onSubmit={this.handleSubmit}/>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="blue-section">
              <p>We have emailed you with a link to verify your email address and reset your password, to the following
                email address:</p>
              <p>{email}</p>
              <p>Please allow up to 5 minutes to receive the link. </p>
              <p>If you have not received the link, please follow the next steps:</p>
              <p>
                <div>1. Check your welcome email or policy documents to confirm the correct email.</div>
                <div>2. Check your junk folder.</div>
                <div>3. If the email is correct, click the resend link button below.</div>
              </p>
            </div>
            {this.state?.resendLinkDisabled ?
              (<div style={{ fontStyle: 'italic', color: 'grey' }}>Resending email. Please check your emails before
                trying again.</div>) :
              (
                <Button
                  onClick={this.resendLink}
                  bsStyle="primary"
                  type="submit"
                  bsSize="small"
                  className="secondary-button"
                >{'RESEND LINK'}</Button>
              )}
          </div>
        )}
      </>
    );
  }

  public render() {
    const pendingRequest = this.isRequestPending();

    return (
      <div className="page-container">
        <div className="login-form">
          {pendingRequest && (
            <>
              {this.sectionTitle(null)}
              <div className="blue-section">
                <p>
                  A request has already been sent, please allow 5 minutes to receive the email to reset your password.
                </p>
              </div>
            </>
          )}
          {!pendingRequest && this.showForm()}
        </div>
      </div>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'forgotten_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('forgotten_password');

    return component;
  },
  connect(
    (state) => {
      return {
        auth: state.auth,
        email: selector(state, 'email'),
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
      },
    }),
  ),
])(ForgottenPassword);
